export const useNotificationBanner = () => {
    // const notificationEnabled = useState<boolean>('a-notification', () => false)
    const notification = useState<any | null>('a-notification', () => null)

    function setNotification(_notification: any) {
        // notificationEnabled.value = true
        notification.value = _notification
    }

    function dismissNotification() {
        notification.value = null
    }



    return {
        notification,
        // notificationEnabled,
        setNotification,
        dismissNotification
    }
}